import { render } from "./FORUM_CANDIDATE_VAL_NEW_V2.vue?vue&type=template&id=7c480a9a"
import script from "./FORUM_CANDIDATE_VAL_NEW_V2.vue?vue&type=script&lang=js"
export * from "./FORUM_CANDIDATE_VAL_NEW_V2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__